<template>
    <div id="filter">
        <form @submit.prevent="onSubmit">
            <v-container>
                <v-row class="text-center">
                    <v-col cols="12">
                        <h2>Filter</h2>
                        <p><strong>Schneller zum gewünschten Ergebnis!</strong><br>
                            Filteroptionen werden aktuell per ODER verknüpft.<br>
                            Bei einer Mehrfachauswahl bedeutet das nicht automatisch das die Betriebe<br>
                            zwingend alle Optionen anbieten sondern nur in einer
                            oder mehreren der ausgewählten Kategorien eingetragen sind.</p>
                    </v-col>
                    <v-col>

                    </v-col>
                </v-row>
                <v-row class="text-center error" v-if="fcounter > 10">
                    <v-col>
                        <strong>Achtung:</strong> Zu viele Optionen ausgewählt! Bitte max. 10 Filteroptionen kombinieren!
                    </v-col>
                </v-row>
                <v-row class="text-center">
                    <v-col cols="12" md="3">
                        <v-select
                            @change="filterCounter"
                            v-model="filter.area"
                            :items="formFilter['area']"
                            item-text="area"
                            item-value="area"
                            multiple
                            filled
                            label="Bundesland"></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select
                            @change="filterCounter"
                            v-model="filter.local"
                            :items="formFilter['local']"
                            item-text="local"
                            item-value="local"
                            multiple
                            filled
                            label="Bezirk"></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select
                            @change="filterCounter"
                            v-model="filter.postcode"
                            :items="formFilter['cities']"
                            item-text="city"
                            item-value="postcode"
                            multiple
                            filled
                            label="Ort"></v-select>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-select
                            @change="filterCounter"
                            v-model="filter.cats"
                            :items="formCats"
                            item-text="title"
                            item-value="id"
                            multiple
                            filled
                            label="Kategorie"></v-select>
                    </v-col>
                </v-row>
                <v-row class="text-center">
                    <v-col cols="12">
                        <v-btn type="submit" :disabled="fcounter < 1 || fcounter > 10">{{ submitBtnText }}</v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </form>
        <Search :items="searchResult" v-show="visible"></Search>
    </div>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import Search from "./Search";

    export default {
        name: "Filtering",
        components: {
            Search
        },
        data () {
            return {
                filter: {
                    area: [],
                    local: [],
                    postcode: [],
                    cats: []
                },
                fcounter: 0,
                visible: false,
                error: false
            }
        },
        methods: {
            ...mapActions(['search']),
            async onSubmit() {
                // console.log(JSON.stringify(this.filter));
                this.visible = true;

                await this.search(this.filter);
            },
            filterCounter() {
                let count = 0;

                for (let item of Object.values(this.filter)) {
                    count += item.length;
                }

                this.fcounter = count;
            },
            flatten(items) {
                let flat = [];

                items.forEach(item =>
                {
                    flat.push(item);

                    if (Array.isArray(item.children) && item.children.length > 0) {
                        flat.push(...this.flatten(item.children));
                    }
                });

                return flat;
            }
        },
        created() {
            if (this.searchresults.length > 0) {
                this.visible = true;
            }
        },
        computed: {
            ...mapState(['categories', 'filteroptions', 'searchresults']),
            formCats() {
                let cats = [];

                if (this.categories && this.categories.length)
                {
                    cats = this.flatten(this.categories);
                }

                return cats;
            },
            formFilter() {
                let filter = [];

                if (this.filteroptions && this.filteroptions.length)
                {
                    filter['area'] = this.filteroptions[0]['area'];
                    filter['local'] = this.filteroptions[1]['local'];
                    filter['cities'] = this.filteroptions[2]['cities'];
                }

                return filter;
            },
            searchResult() {
                let result = [];

                if (this.searchresults && this.searchresults.length)
                {
                    result = this.searchresults;
                }

                return result;
            },
            submitBtnText() {
                let text = 'Bitte Filter wählen';

                if (this.fcounter > 10) {
                    text = 'Bitte einige Optionen wieder entfernen!';
                } else if (this.fcounter > 0) {
                    text = 'Ergebnisse anzeigen';
                }

                return text;
            }
        }
    }
</script>

<style scoped>

</style>